import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/document-properties/Sidebar';
import Main from '../components/document-properties/Main';
import Topbar from '../components/Topbar';
import Properties from '../components/Properties';
import Viewer from '../components/Viewer';
import Downloaded from '../components/Downloaded';
import '../css/Dashboard.css';

const Dashboard = () => {

  useEffect(() => {
    document.title = "Login - Construction and Engineering";  // Set the page title
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Login to your Construction and Engineering Saudi Arabia account.");
    }

    // Add the 'login-body' class to the body
    document.body.classList.add('dashboard-body');

    // Cleanup: Remove the 'login-body' class when the component unmounts
    return () => {
        document.body.classList.remove('dashboard-body');
    };
  }, []);

  return (
    <div className="dashboard">
      <Navbar />
      <div className="content">
        <Topbar />
        <Sidebar />
        <Main />
        <Properties />
        {/* <Viewer /> */}
        {/* <Downloaded /> */}
        
      </div>
      
    </div>
  );
};

export default Dashboard;
